import React from 'react';

import Card from '../../../components/card/card';
import { DeviceAnomaliesList } from './compositions/deviceAnomaliesList';

export function CoreDeviceAnomaliesBeta() {
  return (
    <div className='core-device-anomalies-beta-container'>
      <Card noPadding={true}>
        <div className='core-device-anomalies-beta'>
          <DeviceAnomaliesList />
        </div>
      </Card>
    </div>
  );
}
